import Grid from '@mui/material/Grid';

import ResponsiveImage from '@/components/Image/ResponsiveImage';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import type { GlobalListImageCardContent } from '@/components/TopLevelComponents/GlobalList/GlobalList';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './ImageList.styles';

interface ImageListProps {
  list: GlobalListImageCardContent[] | undefined;
  isOnDark?: boolean | undefined;
}

export default function ImageList({ list, isOnDark }: ImageListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });

  // biome-ignore lint/correctness/noNestedComponentDefinitions: closes over per-render props
  // biome-ignore lint/correctness/noComponentHookFactories: closes over per-render props
  const ImageListItem = ({ item }: { item: GlobalListImageCardContent }) => {
    const { image, heading, body, chipText } = item.fields;

    return (
      <Grid className={classes.ImageListItem} size={6}>
        {image?.[0] && (
          <ResponsiveImage
            className={classes.image}
            src={image[0]}
            width={120}
            height={120}
            sizes={{ xs: 120 }}
            decorative
          />
        )}
        <div className={classes.itemBody}>
          <div className={cx(globalClasses.h4, classes.heading)}>
            {heading}
            {chipText && (
              <span className={cx(globalClasses.chip, classes.chip)}>
                {chipText}
              </span>
            )}
          </div>
          <p className={cx(globalClasses.body, classes.body)}>{body}</p>
        </div>
      </Grid>
    );
  };

  return (
    <GridContainer fixed>
      {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
      {list &&
        list.map((item, index) => (
          <ImageListItem
            key={`icon-list-item-${
              // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
              index
            }`}
            item={item}
          />
        ))}
    </GridContainer>
  );
}
